import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import CityPage from "./pages/CityPage";
import AccessibilityWidget from "./components/AccessibilityWidget";

function App() {
  useEffect(() => {
    document.title = "Pool Builder Orange County, FL | American Pools & Spas";
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* SEO-friendly URLs: /pool-builder/{city-slug}/ */}
          <Route path="/pool-builder/:slug" element={<CityPage />} />
          <Route path="/pool-builder/:slug/" element={<CityPage />} />
          {/* Legacy city route - redirect to new URL */}
          <Route path="/cities/:slug" element={<CityRedirect />} />
          <Route path="/cities/:slug/" element={<CityRedirect />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <AccessibilityWidget />
      </BrowserRouter>
    </div>
  );
}

// 301-style redirect from old /cities/... URLs to new /pool-builder/... URLs
function CityRedirect() {
  const slug = window.location.pathname.replace(/^\/cities\//, '').replace(/\/$/, '');
  return <Navigate to={`/pool-builder/${slug}/`} replace />;
}

export default App;
